import React from "react";
import Battingteam from "./battingteam";
import Boolingteam from "./boolingteam";
import { NavLink } from "react-router-dom";
import qs from "qs";
export default class InningFirst extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...props["res"] };
    this.refetchData = this.refetchData.bind(this);
  }

  componentDidMount() {
    this.refetchData();
    this.setState({
      ...this.props["res"]
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props != nextProps) {
      // this.refetchData(nextProps);
      this.setState({
        ...nextProps["res"]
      });
    }
  }

  refetchData() {
    this.props.fetchData();

    setTimeout(() => {
      this.refetchData();
    }, 10000);
  }

  render() {
    let params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    try {
      params['version'] = params['version'].split('.').join('');
      params['device'] = params['device'].toLowerCase();
    } catch (e) {
      console.log(e.message);
    }
    // 3 try
    let score = this.state.title;

    let teamA = this.state.teamA.players;
    let teamB = this.state.teamB.players;


    // get score
    // 2 try
    try {
      if (this.state.teamA.action == "Batting") {
        score = this.state.teamA.score;
      } else if (this.state.teamB.action == "Batting") {
        score = this.state.teamB.score;
      }
    } catch (e) {

    }

    // 1 try

    try {
      let scoreraw = this.state.inningNumber;
      let innings = this.state.innings;
      let ongoinginningno = Object.keys(innings).length;

      innings = innings[Object.keys(innings).length - 1];

      score = `${innings['name']} - ${innings['scores_full']}`;


    } catch (e) {
      console.log(e.message)



    }

    console.log((params['device'].toLowerCase() == "pwa" && parseInt(params['version']) >= 14) || (params['device'].toLowerCase() == "ios" && parseInt(params['version']) >= 302) || (params['device'].toLowerCase() == "android" && parseInt(params['version']) >= 207));

    return (
      <div>
        <div className="sports_widget_container">
          <div className="sports_widget_section">
            <div className="sports_widget_wrapp">
              {/* <div className="widget_top_section">
                <p className="center">{this.state.title}</p>
              </div> */}

              <div className="widget_top_section">
                <h6
                  className="widget_top_title"
                  style={{ textTransform: "uppercase" }}
                >
                  {this.state.competitionName
                    ? this.state.competitionName
                    : "IPL 2019"}{" "}
                </h6>
                <div className="line_all_center">
                  <div className="horizline_center" />
                </div>
                <h4 className="matchBetwen">{score}</h4>
              </div>

              <div className="widget_body_section_new">
                <div className="pos_rel">
                  <Battingteam
                    team={
                      this.state.teamA.action == "Batting"
                        ? this.state.teamA
                        : this.state.teamB
                    }
                  />
                  <div className="verticle_hr pos_rel">
                    <h5 className="vs1">vs</h5>
                  </div>

                  <Boolingteam
                    team={
                      this.state.teamA.action == "Bowling"
                        ? this.state.teamA
                        : this.state.teamB
                    }
                    this_over={this.state.thisOver}
                  />
                </div>
              </div>
              {/* <div className="widget_footer_section">
                <p className="center" style={{ textTransform: "uppercase" }}>
                  {this.state.competitionName
                    ? this.state.competitionName
                    : "IPL 2019"}{" "}
                </p>
              </div> */}
            </div>
          </div>
        </div>
        {
          ((params['device'] == "pwa" && parseInt(params['version']) >= 14) || (params['device'] == "ios" && parseInt(params['version']) >= 302) || (params['device'] == "android" && parseInt(params['version']) >= 207)) ? <div className="space_between targrt_score_wrap" >
            <h4 className="targrt_score" style={{ "paddingBottom": "10px" }}>{this.state.testMatchStatus} </h4>

            <h4 className="tap_for_more">tap for more</h4>
          </div> : ""
        }

      </div>
    );
  }
}
